var _mask, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.48275862068965,
    height: 22.00054931640625,
    viewBox: "0 0 20.48275862068965 22.00054931640625",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bg-mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bg-mask-0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 1",
    fillRule: "evenodd",
    style: {
      fill: "#030000"
    },
    opacity: 1,
    d: "M0 1.59L20.48 1.59L20.48 0L0 0L0 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 2",
    fillRule: "evenodd",
    style: {
      fill: "#030000"
    },
    opacity: 1,
    d: "M9.45562 22.0005L11.0256 22.0005L11.0256 5.41053L17.4856 11.9405L18.5956 10.8105L11.3556 3.49053L10.2456 2.36053L9.12562 3.49053L1.88562 10.8105L2.99562 11.9405L9.45562 5.41053L9.45562 22.0005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path_0",
    x: 0,
    y: 0,
    width: 20.48275862068965,
    height: 22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTop);
export default __webpack_public_path__ + "static/media/toTop.1c7f14eab83930b4c42eed75574f8687.svg";
export { ForwardRef as ReactComponent };